import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../api';

interface Agent { name: string; status: string; restarts: number; cpu: number; memory: number; }

const AGENT_KEYS: Record<string, string> = {
  'test-agent': 'agent.test',
  'kvass-agent': 'agent.kvass_tester',
  'changelog-agent': 'agent.changelog',
  'testdata-agent': 'agent.testdata',
  'testdekning-agent': 'agent.coverage',
};

export default function Agents() {
  const { t } = useTranslation();
  const [agents, setAgents] = useState<Agent[]>([]);
  const [error, setError] = useState('');

  const load = async () => {
    try {
      const res = await api.get('/agents');
      setAgents(Array.isArray(res.data) ? res.data : []);
    } catch {
      setError('Failed to load agents');
    }
  };

  useEffect(() => { load(); }, []);

  const action = async (name: string, act: string) => {
    await api.post(`/agents/${name}/${act}`);
    setTimeout(load, 1000);
  };

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">{t('agents.title')}</h1>
      {error && <div className="bg-red-900 text-red-200 rounded px-4 py-2 mb-4">{error}</div>}
      <div className="space-y-3">
        {agents.length === 0 && !error && <div className="text-gray-500">No agents found</div>}
        {agents.map(agent => {
          const key = AGENT_KEYS[agent.name] || agent.name;
          return (
            <div key={agent.name} className="bg-gray-800 rounded-xl p-5 flex items-center justify-between">
              <div>
                <div className="font-semibold">{t(key)}</div>
                <div className="text-sm text-gray-400 mt-1">{t(`${key}.desc`)}</div>
                <div className="text-xs text-gray-500 mt-2">
                  CPU: {agent.cpu}% · RAM: {Math.round(agent.memory / 1024 / 1024)}MB · {t('agents.status')}: {agent.status}
                </div>
              </div>
              <div className="flex gap-2 ml-4">
                <button onClick={() => action(agent.name, 'restart')} className="px-3 py-1 bg-yellow-700 hover:bg-yellow-600 rounded text-sm transition-colors">{t('agents.restart')}</button>
                {agent.status === 'online'
                  ? <button onClick={() => action(agent.name, 'stop')} className="px-3 py-1 bg-red-700 hover:bg-red-600 rounded text-sm transition-colors">{t('agents.stop')}</button>
                  : <button onClick={() => action(agent.name, 'start')} className="px-3 py-1 bg-green-700 hover:bg-green-600 rounded text-sm transition-colors">{t('agents.start')}</button>
                }
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
